import { EMR_APIS } from "@/api_framework/api_config";
import { IEMRSectionSearchResponse, IEMRSectionSearchResponseData } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
export type SectionSearchDataTypes = "surgery" | "Lab" | "Treatment" | "Deworming" | "Food" | "Medicines" | "diagnosis";

export const useEMRSectionSearchAPI = () => {
  const configuration = useConfiguration();
  const [searchResults, setSearchResults] = useState<IEMRSectionSearchResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const clearSearchResults = () => {
    setSearchResults([]);
  };
  const execute = useCallback(
    async (
      searchQuery: string,
      searchType: SectionSearchDataTypes,
      clinicId: string,
      petId: string,
      emr_id?: string,
      emr_type?: string,
    ) => {
      try {
        dispatch(
          setLoading({
            key: "isCustomerEmrSearchInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response = await axios
          .get(EMR_APIS?.SECTION_SEARCH?.baseURL ?? "", {
            params: {
              search_keyword: searchQuery,
              search_data_type: searchType,
              clinic_id: clinicId,
              pet_id: petId,
              emr_id: emr_id,
              emr_type: emr_type,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IEMRSectionSearchResponse>) => {
            dispatch(
              setLoading({
                key: "isCustomerEmrSearchInProgress",
                status: false,
              }),
            );
            if (res.data.status === true && res.data) {
              setSearchResults(res.data.data);
              return res.data.data;
            } else {
              setSearchResults([]);
              return [];
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isCustomerEmrSearchInProgress",
                status: false,
              }),
            );
            captureError(e);
            sendCurl(e.config["curlCommand"]);
            setSearchResults([]);

            if (e.response.status === 500) {
              toast.error("Server error, please contact tech team.");
            }
            return [];
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isCustomerEmrSearchInProgress",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { searchResults, clearSearchResults, execute };
};
